<template lang="pug">
.right_box_main
    // 面包屑导航
    .mianbao
        el-breadcrumb(separator-class='el-icon-arrow-right')
            el-breadcrumb-item(:to="{ path: '/griddingindex' }") 网格工作
            el-breadcrumb-item 社区议事协商
            el-breadcrumb-item 数据字典
            el-breadcrumb-item 人员类别
    .card-box
        // 左边卡片
        el-card.card-l(:body-style="{ padding: '10px'}")
            el-input(placeholder='输入关键字过滤', size='mini', v-model='filterText', style='margin-bottom:3px;')
            el-tree.filter-tree(ref='tree', :data='treedata', :props='defaultProps', node-key='id', default-expand-all='', :expand-on-click-node='false', :render-content='renderContent', :filter-node-method='filterNode')
        // 右边卡片
        .card-rb
            .card-4
                el-card(:body-style="{ padding: '16px' }")
                    .fisthang
                        el-form.demo-form-inline(:inline='true', :model='searchlist', size='mini')
                            el-form-item(label='上级类别:')
                                el-select(v-model='searchlist.parentId', placeholder='--请选择--', style='width:130px')
                                    el-option(v-for='item in pTypes', :key='item.value', :label='item.label', :value='item.value')
                            el-form-item(label='类别名称:')
                                el-input(v-model='searchlist.consultName', placeholder='请输入', style='width:130px')
 
                            el-form-item
                                el-button(type='primary', @click='searchlistdata') 查询
                            el-form-item
                                el-button(type='info', @click='searchlistReset') 重置
                    .three
                        el-button(type='primary', size='mini', @click='showDialogForm("","0")') 新增
                        // <el-button type="danger" size="mini">导出Excel</el-button>
                        // 表格盒子
                        .table_card
                            el-table(:data='tableData', :header-cell-style="{ background: '#f8fafa' }", border='', size='mini', align='center', current-row-key='', highlight-current-row='')
                                // <el-table-column type="selection" align="center" width="100px"></el-table-column>
                                el-table-column(type='index', align='center', label='序号', width='50')
                                el-table-column(align='center', prop='consultName', label='类别名称')
                                el-table-column(align='center', prop='remarks', label='备注', width='100px')
                                el-table-column(align='center', prop='status', label='状态', width='100px')
                                    template(scope='scope')
                                        el-switch(v-permission="{sign:'sjzd:ytlbwh:ztxg'}", v-model='scope.row.status', active-value='0', inactive-value='1', @change='changeStatus(scope.row)')
                                el-table-column(align='center', label='操作', width='160px', fixed='right')
                                    template(slot-scope='scope')
                                        el-tooltip.item(effect='light', content='查看', placement='top-start')
                                            button.iconfont.icon-chakan.tabBtn(@click='showDialogFormLook(scope.row.id)')
                                        el-tooltip.item(effect='light', content='编辑', placement='top-start')
                                            button.iconfont.icon-bianji3.tabBtn(@click='showDialogForm(scope.row.id)')
                                        el-tooltip.item(effect='light', content='删除', placement='top-start')
                                            button.iconfont.icon-icon7.tabBtn(@click='showdeletepanduan(scope.row.id)')
                            // 分页功能
                            el-pagination(:page-size='10', layout='total, prev, pager, next, jumper', @current-change='handleCurrentChange', :total='pageConfig.total')
    // 弹出框新增
    el-dialog(:title='dialogTitle', :visible.sync='showadd', width='500px')
        el-form(ref='addform', :model='addform', :rules='rules', label-width='110px', size='mini')
            el-form-item(label='上级类别:')
                el-select(v-model='addform.parentId', @change='selectDisposeCode', placeholder='--请选择--', style='width: 300px;', :disabled='readyOnly')
                    el-option(v-for='item in pTypes', :key='item.value', :label='item.label', :value='item.value')
            el-form-item(label='类别名称:', prop='consultName')
                el-input(v-model='addform.consultName', style='width: 300px;', :disabled='readyOnly')
            el-form-item(label='状态：', prop='status')
                el-radio-group(v-model='addform.status', @change='selectDisposeCode', :disabled='readyOnly')
                    el-radio(label='0') 启用
                    el-radio(label='1') 禁用
            el-form-item(label='备注：')
                el-input(type='textarea', v-model='addform.remarks', style='width: 300px;', :disabled='readyOnly')
        .boontbtn
            el-button(type='primary', rows='4', size='small', style='margin: 0 30px', @click='saveadddata') 保存
            el-button(type='info', size='small', @click='clearadddata') 取消

</template>

<script>
import request from "../../../utils/request.js";
import { consulTypePersionApi, getTypeById_p } from "@/api/http.js";
let token = JSON.parse(window.localStorage.getItem("user"));

export default {
  data() {
    return {
      readyOnly: false,
      dialogTitle: "新增",
      filterText: "",
      searchlist: {},
      //  树形控件
      treedata: [],
      // 树形控件的配置
      defaultProps: {
        children: "children",
        label: "consultName"
      },
      //表格数据
      tableData: [],
      // 分页配置
      pageConfig: {
        pageSize: 10,
        total: 0,
        pageNo: 1
      },
      // 新增弹出层
      showadd: false,
      addform: {
        parentId: "0"
      },
      rules: {
        consultName: [
          { required: true, message: "请输入类别名称", trigger: "blur" }
        ],
        status: [
          { required: true, message: "请选启动状态", trigger: "change" }
        ],
        sort: [
          { required: true, message: "请输入排序值", trigger: "blur" },
          {
            type: "number",
            min: 0,
            message: "排序必须为数字值",
            trigger: "blur"
          }
        ]
      },
      //父级类
      pTypes: [],
      findConsultPersonType: []
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    showadd(val) {
      if (!val) {
        this.readyOnly = false;
        this.$refs["addform"].resetFields();
      }
    }
  },
  methods: {
    //树形列表
    filterNode(value, data) {
      if (!value) return true;
      return data.consultName.indexOf(value) !== -1;
    },
    renderContent(h, { node, data, store }) {
      return (
        <span style="padding-right:6px;">
          <span>
            <el-button style="font-size:12px;color:#666" type="text">
              {node.label}
            </el-button>
          </span>
          <span style="display:none;">
            <el-button
              style="font-size:12px;color:#666"
              type="text"
              on-click={() => this.showDialogForm(data.id, data.parentId)}
            >
              {node.label}
            </el-button>
          </span>
          <span style="display:none;">
            <el-button
              style="font-size:12px;"
              type="text"
              on-click={() => this.showDialogForm(0, data.id)}
            >
              +
            </el-button>
            <el-button
              style="font-size:12px;"
              type="text"
              on-click={() => this.showdeletepanduan(data.id)}
            >
              -
            </el-button>
          </span>
        </span>
      );
    },
    formateTree(arr) {
      var temp = [];
      if (arr.length > 0) {
        arr.forEach(item => {
          var children = [];
          if (item.children != null && item.children.length > 0) {
            children = this.formateTree(item.children);
          }
          temp.push({
            id: item.id,
            label: item.consultName,
            children: children
          });
        });
      }
      return temp;
    },
    //条件查询
    searchlistdata() {
      this.pageConfig.pageNo = 1;
      this.getPageDatas();
    },
    searchlistReset() {
      this.searchlist = {};
      this.pageConfig.pageNo = 1;
      this.getPageDatas();
    },
    //分页
    handleCurrentChange(val) {
      this.pageConfig.pageNo = val;
      this.getPageDatas();
    },
    //获取列表数据
    async getPageDatas() {
      var res = await consulTypePersionApi.getTableData({
        token: token,
        pageNo: this.pageConfig.pageNo,
        pageSize: this.pageConfig.pageSize,
        parentId: this.searchlist.parentId
      });

      if (res.code == 200) {
        this.pageConfig.total = res.content.count;
        this.tableData = res.content.list;
      } else {
        console.log(res);
        this.$message({
          message: "数据加载异常：",
          type: "error"
        });
      }
    },

    async getTreeDatas() {
      var res = await consulTypePersionApi.getTypTreeeData({
        pageNo: 1
        // pageSize: 9999,
        // parentId: 0
      });

      if (res.content && res.content.length > 0) {
        // this.treedata = [
        //   {
        //     id: 0,
        //     label: "议题类型",
        //     children: this.formateTree(res.content)
        //   }
        // ];
        this.treedata = res.content;
      }
    },
    //获取条件查询的一级分类
    async getPTypes() {
      var res = await consulTypePersionApi.getTypeData({});
      //   var res = await request({
      //     url: "/consultPersonType/info/findConsultPersonType",
      //     method: "POST",
      //     data: {
      //       token: token
      //     }
      //   });
      var temp = { value: 0, label: "--无父级--" };
      this.findConsultPersonType = res.content || "";
      this.pTypes = [];
      this.pTypes.push(temp);
      if (res.content.length > 0) {
        res.content.forEach(item => {
          temp = { value: item.id, label: item.consultName };
          this.pTypes.push(temp);
        });
      }
    },
    //解决select框无法选中的情况
    selectDisposeCode() {
      this.$forceUpdate();
    },
    //改变状态
    async changeStatus(cdata) {
      let params = JSON.parse(JSON.stringify(cdata));

      var res = await consulTypePersionApi.insert(params);
      //   var res = await request({
      //     url: "/consulType/info/insertConsultType",
      //     method: "POST",
      //     data: fd
      //   });
      var msg = "分类-" + cdata.consultName + "，状态";
      msg = msg + (cdata.status == "0" ? "启用" : "禁用");
      if (res.code == 200) {
        this.$message({
          message: msg + "成功",
          type: "success"
        });
      } else {
        this.$message({
          message: msg + "失败：" + res.message,
          type: "error"
        });
      }
    },
    // 取消
    clearadddata() {
      this.showadd = false;
    },

    showDialogFormLook(id) {
      this.readyOnly = true;
      this.showDialogForm(id);
    },
    //新增框 带着父类id
    async showDialogForm(id, pid) {
      //编辑
      if (id > 0) {
        this.dialogTitle = "编辑";
        //获取编辑项的最新数据
        var res = await consulTypePersionApi.getDetail({
          token: token,
          id: id
        });
        // var res = await request({
        //   url: "/consultPersonType/info/findConsultPersonTypeById",
        //   method: "POST",
        //   data: {
        //     token: token,
        //     id: id
        //   }
        // });
        // console.log(res)
        if (res.code == 200) {
          res.content.parentId = Number(res.content.parentId);
          this.addform = res.content;
          this.showadd = true;
        } else {
          //   console.log(res.code + "：" + res.message);
          this.$message({
            message: "编辑项加载异常",
            type: "error"
          });
          this.showadd = false;
        }
      } else {
        this.showadd = true;
        this.dialogTitle = "新增";
        this.addform = {};
        this.addform.parentId = Number(pid);
      }
    },
    //获取新增所有数据发请求
    async saveadddata() {
      let fd = new FormData();
      let params = JSON.parse(JSON.stringify(this.addform));
      params.token = token;

      var res = await consulTypePersionApi.insert(params);
      //   console.log(params);
      //   var res = await request({
      //     url: "/consultPersonType/info/insertConsultPersonType",
      //     method: "POST",
      //     data: params
      //   });
      if (res.code == 200) {
        this.$message({
          message: this.dialogTitle + "成功",
          type: "success"
        });
        this.showadd = false;
        this.getPTypes();
        this.getTreeDatas();
        this.pageConfig.pageNo = 1;
        this.getPageDatas();
      } else {
        this.$message({
          message: this.dialogTitle + "失败：" + res.message,
          type: "error"
        });
      }
    },
    //删除操作
    async showdeletepanduan(id) {
      this.$confirm("此操作将删除该信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          let fd = new FormData();
          fd.append("token", token);
          fd.append("id", id);

          var res = await consulTypePersionApi.delete({
            token: token,
            id: id
          });

          //   var res = await request({
          //     url: "/consultPersonType/info/deleteConsultPersonType",
          //     method: "POST",
          //     data: {
          //       token: token,
          //       id: id
          //     }
          //   });
          //   console.log(res);
          if (res.code == 200) {
            this.$message({
              message: "删除成功",
              type: "success"
            });
            this.showadd = false;
            this.getPTypes();
            this.getTreeDatas();
            this.pageConfig.pageNo = 1;
            this.getPageDatas();
          } else {
            this.$message({
              message: "删除失败：" + res.message,
              type: "error"
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    }
  },
  mounted() {
    this.getPTypes();
    this.getTreeDatas();
    this.getPageDatas();
  }
};
</script>

<style lang="less" scoped>
.filter-tree .el-input__inner {
  height: 30px;
  line-height: 30px;
}
//  包裹两个卡片的盒子
.card-box {
  display: flex;
  // 左边树状列表卡片
  .card-l {
    margin-left: 10px;
    width: 300px;
    overflow-x: auto;
  }
  // 右边卡片
  .card-rb {
    width: calc(100% - 300px);
    // width: 100%;
  }
}
// 表格的盒子
.table_card {
  // overflow: hidden;
  // 解决表格无法自适应宽度
  // width: calc(100vw - 500px);
  margin: 16px 0 0 0;
  .el-table {
    width: 100%;
    // 表格里的按钮
    .tabBtn {
      margin: 0 6px;
    }
    .tabBtn:nth-child(1) {
      color: #199b5d;
    }
    .tabBtn:nth-child(2) {
      color: #a1a1a1;
    }
    .tabBtn:nth-child(3) {
      color: #dd3020;
    }
    .tabBtn:nth-child(4) {
      color: #2e99cf;
    }
    .active_Btn {
      color: #ff04ed !important;
    }
  }
}
</style>
